import createInstance from './create.js';

// 基础的Axios实例，请求配置以及拦截器都是使用的通用的配置
const baseInstance = createInstance(
  {
    baseURL: process.env.VUE_APP_BASE_URL,
  },
  [],
  [],
);

// Shop业务可能前缀都是/shop，可以在这里统一处理，
// 如果需要对请求和返回做特殊处理，也可以在这里加拦截器
const shopInstance = createInstance(
  {
    baseURL: '/shop',
  },
  [],
  [],
);

// 增加用户模块实例
const userInstance = createInstance(
  {
    baseURL: '/user',
  },
  [],
  [],
);

export { baseInstance, shopInstance, userInstance };
